module.exports = ["caption","icon","menu","message-box","small-caption","status-bar"]


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-system-font-keywords/index.json
// module id = 1079
// module chunks = 0